<template>
  <!--  -->
  <div class="side-panel right com-right hf osy mr-30">
    <div class="side-panel-bg p-20 pb-0">
      <h1 class="f-20 c-satwo">
        <span>网络安全监测 <img src="/imgs/complianceTitleIcon.png" class="ml-10"></span>
      </h1>
      <div class="data-bar comCenterTxt mt-15" style="vertical-align: bottom;">
        <div class="data-item mr-15">
          <span class="di-name">告警: </span>
          <span class="di-value" style="color: #FF2F2F;">{{ nsEventCount.alerm }}</span>
        </div>
        <div class="data-item ml-15">
          <span class="di-name">确认: </span>
          <span class="di-value" style="color: #56FC1D;">{{ nsEventCount.event }}</span>
          &nbsp;
          <span class="di-unit">事件</span>
        </div>
      </div>

      <h3 class="f-14 pt-10 c-satwotitle">攻击来源 TOP3</h3>
      <div class="fr mb-10">
        <div class="fr attacklist-title">
          <div class="attacklist-id">序号</div>
          <div class="attacklist-ip">IP</div>
          <div class="attacklist-country">国家</div>
          <div class="attacklist-count">攻击次数</div>
        </div>
      </div>
      <div class="fr attacklist-row mt-5" v-for="(item, index) in nsEventSource" :key="index">
        <div class="fr jc ac attacklist-id">
          <div :class="'attacklist-toptag-'+index">TOP {{ index + 1 }}</div>
        </div>
        <div class="fr jc ac f-12 attacklist-ip"><span>{{ item.IP }}</span></div>
        <div class="fr jc ac f-12 attacklist-country"><span>{{ item.country }}</span></div>
        <div class="fr jc ac f-12 c-red attacklist-count"><span>{{ item.number }}</span></div>
      </div>
      <h3 class="f-14 pt-10 c-satwotitle">网络安全事件类型分布</h3>
      <div class="fr ov bleftOne">
        <chart-doughnut-event-type :data="nsEventType" showLabel class="f1 oh mt-20"
                                   style="width: 100%; height: 180px;"/>
      </div>

      <h1 class="f-20 c-satwo mt-10">
        <span>信息安全监测 <img src="/imgs/complianceTitleIcon.png" class="ml-10"></span>
      </h1>
      <div class="fr idc-act-row mt-15">
        <div class="fr f-12" style="width:100px;">
          <span class="mr-5 idc-act-label">域名: </span>
          <span class="idc-act-value">{{ idcActData.domain }}</span>
        </div>
        <div class="fr f-12" style="width:130px;">
          <span class="mr-5 idc-act-label">IP: </span>
          <span class="idc-act-value">{{ idcActData.IP }}</span>
        </div>
        <div class="fr f-12" style="width:130px;">
          <span class="mr-5 idc-act-label">URL: </span>
          <span class="ml-5 idc-act-value">{{ idcActData.URL }}</span>
        </div>
      </div>
      <div class="fr idc-act-row mt-5">
        <div class="fr f-12" style="width:140px;">
          <span class="mr-5 idc-act-label" style="width:100px;">互联网接入: </span>
          <span class="ml-5 idc-act-value">{{ idcActData.internetAccess }}</span>
        </div>
        <div class="fr f-12" style="width:240px;">
          <span class="mr-5 idc-act-label" style="width:120px;">出口带宽: </span>
          <span class="ml-5 idc-act-value">{{ idcActData.internetBandwidth }}</span>
        </div>
      </div>
      <div class="fr idc-act-row mt-5">
        <div class="fr f-12" style="width:140px;">
          <span class="mr-5 idc-act-label" style="width:100px;">跨境数据传输: </span>
          <span class="ml-5 idc-act-value">{{ idcActData.crossDataTransfer }}</span>
        </div>
        <div class="fr f-12" style="width:240px;">
          <span class="mr-5 idc-act-label" style="width:120px;">敏感数据传输: </span>
          <span class="ml-5 idc-act-value">{{ idcActData.sensitiveDataTransfer }}</span>
        </div>
      </div>
      <h3 class="f-14 pt-20 c-satwotitle">网络协议 TOP5</h3>
      <div class="fr ov bleftOne" style="background: rgba(0, 145, 133, 0.12);">
        <chart-bar-protocol :chartData="protocolTop"
                            style="width: 100%; height: 172px; margin-left:10px; margin-right:5px;" />
      </div>
    </div>
  </div>
</template>

<script>
import chartDoughnutEventType from "@/views/sascreen/compliance/chart-doughnut-event-type.vue"
import chartBarProtocol from "@/views/sascreen/compliance/chart-bar-protocol.vue"

export default {
  name: 'com-right',
  components: {
    chartDoughnutEventType,
    chartBarProtocol,
  },
  props: {
    resData: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      nsEventCount: {},
      nsEventSource: [],
      nsEventType: [],
      idcActData: {},
      protocolTop: [],
    }
  },
  mounted() {
    this.$nextTick(function () {
      // 初始化dom相关数据
      setTimeout(() => {
        this.nsEventCount = this.resData.nsEventCount
        this.nsEventSource = this.resData.nsEventSource
        this.nsEventType = this.resData.nsEventType
        this.idcActData = this.resData.idcActData
        this.protocolTop = this.resData.protocolTop
      }, 300)
    })
  },
  beforeDestroy() {
  },
  methods: {}
}
</script>
<style scoped>
.side-panel-bg{
  background: rgba(0,0,0,0) !important;
}
.monitorcont dl {
  width: 25%;
  float: left;
}

.monitorcont dl dt {
  margin-bottom: 2px;
}

.monitorcont dl dd:last-child {
  font-size: 10px;
  margin-bottom: 5px;
}

.centerNewsCon .centerNewsContitle {
  width: 90%;
  height: 24px;
  line-height: 22px;
  list-style-type: disc;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-top: 5px;
}

.centerNewsCon .ellipsisBox {
  list-style-type: disc;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 20px;
  margin-top: 5px;
}

.centerNewsCon .blikunnewsicon {
  position: absolute;
  right: 7px;
  top: 23px;
}

.data-bar {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.data-item {
  vertical-align: bottom;
  display: flex;
  align-items: flex-end;
}

.di-name {
  color: #d4d8da;
  font-size: 14px;
  line-height: 14px;
  vertical-align: bottom;
  margin-right: 5px;
}

.di-value {
  font-size: 18px;
  line-height: 16px;
  font-weight: normal;
  vertical-align: bottom;
  display: flex;
  align-items: flex-end;
}

.di-unit {
  font-size: 13px;
  line-height: 13px;
  vertical-align: bottom;
}

.attacklist-title {
  margin-top: 10px;
  padding: 0;
  width: 100%;
  height: 41px;
  background: url(/imgs/blikunnewsbg.png) no-repeat;
  background-size: 100% 41px;
  position: relative;
  line-height: 41px;
  font-size: 14px;
}

.attacklist-row {
  background: rgba(0, 145, 133, 0.12);
  border-radius: 2px;
  height: 36px;
}

.attacklist-id {
  width: 85px;
  height: 100%;
  text-align: center;
}

.attacklist-ip {
  width: 106px;
  text-align: center;
}

.attacklist-country {
  width: 100px;
  text-align: center;
}

.attacklist-count {
  width: 100px;
  text-align: center;
}

.attacklist-toptag-0 {
  background: rgba(240, 68, 68, 0.46);
  border: 1px solid rgba(240, 68, 68, 1);
  border-radius: 2px;
  padding: 0px 5px;
  font-size: 12px;
  height: 24px;
}

.attacklist-toptag-1 {
  background: rgba(240, 120, 68, 0.46);
  border: 1px solid rgb(240, 100, 68);
  border-radius: 2px;
  padding: 0px 5px;
  font-size: 12px;
  height: 24px;
}

.attacklist-toptag-2 {
  background: rgba(68, 238, 240, 0.30);
  border: 1px solid rgba(68, 238, 240, 1);
  border-radius: 2px;
  padding: 0px 5px;
  font-size: 12px;
  height: 24px;
}

.idc-act-row {
  border-radius: 2px;
  height: 32px;
}

.idc-act-label {
  color: #FFF;
  font-size: 12px;
  line-height: 32px;
  text-align: right;
  width: 75px;
}

.idc-act-value {
  color: #00FDFD;
  font-size: 18px;
  line-height: 32px;
}

.c-satwo{
  background: url(/imgs/complianceTitle.png) no-repeat;
  height: 40px;
  
}
.c-satwo span{
  font-size: 18px;
  color: #FFFFFF;
  letter-spacing: 0;
  font-weight: 400;
  padding-left: 37px;
  line-height: 40px;
}
</style>
